import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'contextualMenu.stylesOnMap.order.title' }),
    subtitle: translate({ id: 'contextualMenu.stylesOnMap.depot.subTitle' }),
    show: translate({ id: 'contextualMenu.stylesOnMap.order.show' }),
    reduce: translate({ id: 'contextualMenu.stylesOnMap.order.reduce' }),
    hide: translate({ id: 'contextualMenu.stylesOnMap.order.hide' }),
  }))

  return api
}
